import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import BrowserDetectInfo from 'browser-detect';
import { Observable } from 'rxjs';
import { MSRemoteLoggerCategory } from '../adapters/remote-logger/utils/remote-logger.utils';
import { CONSTANTS } from '../services/config.service';
import { LoggerService } from '../services/logger.service';
import { NavigationService } from '../services/navigation/navigation.service';
import { RegistrationService } from '../services/registration/registration.service';
import { UrlService } from '../services/url.service';

@Injectable({
  providedIn: 'root'
})
export class SetupGuard implements CanActivate {
  navigationTrigger = '';

  constructor(
    private navCtrl: NavController,
    private nav: NavigationService,
    private logger: LoggerService,
    private registration: RegistrationService,
    private url: UrlService
  ) {
    this.url.navigationTrigger$.subscribe((navigationTrigger: string) => {
      this.navigationTrigger = navigationTrigger;
    });
  }

  unsupportedBrowser() {
    const browserDetails = BrowserDetectInfo();
    const name = browserDetails.name;
    const version = browserDetails.versionNumber;
    // https://ionicframework.com/docs/reference/browser-support
    return name === 'ie' || (name === 'edge' && version < 79);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url = next.url[0].path;

    if (this.navigationTrigger === 'popstate') {
      return false;
    }
    this.logger.log('Setup guard - registration initialized:', MSRemoteLoggerCategory.SETUP_GUARD_SERVICE, CONSTANTS.registrationInitialized);

    const nav = (target) => {
      this.logger.log('User navigating to:', MSRemoteLoggerCategory.SETUP_GUARD_SERVICE, url, 'App says go to:', target);

      if (target[0] === '/' + url) {
        return true;
      } else {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.nav.nav(target);
        return false;
      }
    };

    if (this.unsupportedBrowser()) {
      // return new Promise(resolve => { this.nav.nav('/unsupported'); resolve(false) })
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.nav.nav('/unsupported');
      return false;
    } else if (CONSTANTS.appInitialized) {
      this.logger.log('Registration getNextPage', MSRemoteLoggerCategory.SETUP_GUARD_SERVICE);
      return this.registration.getNextPage().then((target) => nav(target));
    } else if (CONSTANTS.registrationInitialized) {
      this.logger.log('Registration goToNextPage', MSRemoteLoggerCategory.SETUP_GUARD_SERVICE);
      return this.registration.goToNextPage().then((target) => nav(target));
    } else {
      this.logger.log('Initializting Registration', MSRemoteLoggerCategory.SETUP_GUARD_SERVICE);
      return this.registration.initialize().then((target) => nav(target));
    }
  }
}
